import {getStudentViewModeFromString, StudentViewMode} from '../constants';
import {dynamicEnv} from "../dynamic/dynamicEnv";
import {throwOnUnset} from "../../global/utils/throwOnUnset";

export type PathConfig = {
  ROOT_URL: string;
  PATH_TO_PUBLIC_FOLDER: string;
  SKIN_URL: string;
};

const STUDENT_VIEW_MODE = getStudentViewModeFromString(throwOnUnset(dynamicEnv('VIEW_MODE'), "VIEW MODE missing"));

export const PATH_CONFIG: PathConfig = {
  ROOT_URL: prepareRootUrl() ?? '',
  PATH_TO_PUBLIC_FOLDER: preparePathToPublicFolder(), //path to v360files, etc..
  SKIN_URL: dynamicEnv('SKIN_URL') ?? prepareDefaultSkinPath(),
};

function prepareRootUrl(): string | null {
  return dynamicEnv('ROOT_URL') ?? window.location.origin;
}

function preparePathToPublicFolder(): string {
  return dynamicEnv('PATH_TO_PUBLIC_FOLDER') ?? prepareDefaultPathToPublicFolder();
}

function prepareDefaultPathToPublicFolder(): string {
  if (
    StudentViewMode.ExportedPackaged_NullClient === STUDENT_VIEW_MODE ||
    StudentViewMode.Offline_SCORM === STUDENT_VIEW_MODE ||
    StudentViewMode.Offline_TinCan === STUDENT_VIEW_MODE ||
    StudentViewMode.Offline === STUDENT_VIEW_MODE
  ) {
    return parseSystemPath();
  }

  return '/Scripts/editorReact/'; //defaults to, because of production
}

function parseSystemPath(): string {
  const fullPathToCurrentHtmlFile = window.location.pathname.split('/');
  fullPathToCurrentHtmlFile.pop();

  return fullPathToCurrentHtmlFile.reduce((rootPath, path) => rootPath + path + '/', '');
}

function prepareDefaultSkinPath(): string {
  const rootPath = preparePathToPublicFolder();
  return `${rootPath}360files/skin/skin.xml`;
}
